export default __webpack_public_path__ + "f0414675dbd9d2aef2b1edd3d8c5dd3f.svg";